export const isAgent360 = (name) => {
    return ([
        'Auto',
        'Home',
        'Umbrella',
        'Auto 5.0',
        'Home 5.0',
        'Umbrella 5.0',
        'Landlord 5.0',
        'Condo 5.0',
    ].indexOf(name) > -1);
};

